import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { LocalStorageService } from '../services/local-storage.service';
import { environment } from 'src/environments/environment';
import { decrypt } from './crypt.helper';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor() { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!req.url.includes('https://viacep.com.br')) {
      const accessToken = JSON.parse(decrypt(sessionStorage.getItem(environment.localpoints.authResult))).accessToken;
      let request = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${accessToken}`)
      });
      return next.handle(request);
    } else {
      return next.handle(req);
    }
  }
}
